import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ShowDate } from 'framework/ui/ui-builder';
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { DATE_FORMAT } from 'framework/utils';
import { COMPLIANCE_CONTROL_MODE } from '../../constants';
import { ComplianceControlMode } from '../../types';

interface ComplianceControlModeFieldProps extends FieldProps<ComplianceControlMode> {
  enforceAtSource: string;
}

const MODE_LABELS: Record<ComplianceControlMode, string> = {
  [COMPLIANCE_CONTROL_MODE.ENFORCED]: 'Enforced',
  [COMPLIANCE_CONTROL_MODE.ADVISORY]: 'Advisory',
  [COMPLIANCE_CONTROL_MODE.DISABLED]: '—',
};

const ComplianceControlModeField = ({ source, enforceAtSource }: ComplianceControlModeFieldProps) => {
  const { getValue: getMode } = useFieldHelper<ComplianceControlMode>({ source });
  const { getValue: getEnforceAt } = useFieldHelper<string | null>({ source: enforceAtSource });
  const mode = getMode();
  const enforceAt = getEnforceAt();

  return (
    <Stack>
      <Typography variant="body1">{MODE_LABELS[mode]}</Typography>
      {mode === COMPLIANCE_CONTROL_MODE.ADVISORY && enforceAt && (
        <Typography variant="caption" color="textSecondary">
          becomes enforced on
          <ShowDate dateUTC={enforceAt} format={DATE_FORMAT.SIMPLE} isDateTime={false} variant="caption" />
        </Typography>
      )}
    </Stack>
  );
};

export default ComplianceControlModeField;
